import css from 'styled-jsx/css';
import { colors } from '../../../config/styles';

const style = css`
  .item-container {
    border: solid ${colors.gray.shade17};
    padding: 0.8em;
    border-radius: 0.5em;
    margin-top: 0.5em;
    margin-bottom: 0.5em;
  }
`;
export { style };
